<template>
  <div class="page-card">
    <div class="content">
      <div class="step-wrap">
        <div class="step-item">
          <span class="step-num">1</span>
          <span>身份注册</span>
        </div>
        <div class="step-icon">———</div>
        <div class="step-item">
          <span class="step-num">2</span>
          <span>绑定卡号</span>
        </div>
        <div class="step-icon">———</div>
        <div class="step-item">
          <span class="step-num">3</span>
          <span>足额提现</span>
        </div>
      </div>
      <div class="card-content">
        <div class="title">最高可借额度（元）</div>
        <div class="num">15000</div>
        <div class="pageCardList">
          <div v-for="item in pageCardList" :key="item.id" class="pageCardItem">
            <img class="icon" :src="item.icon" alt="" />
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageCardList } from "@/utils/const";
export default {
  components: {},
  name: "PageCard",
  data() {
    return {
      pageCardList,
    };
  },
  methods: {},
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
};
</script>

<style scoped lang="scss">
.page-card {
}
.content {
  margin: 0px 16px;
  .step-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    padding: 16px 16px 30px 16px;
    background-image: url("@/assets/style/landingPage/loan-success-tip-bg.png");
    background-size: 100% 100%;
    color: #fff;
    .step-icon {
      color: rgba(255, 255, 255, 0.2);
    }
    .step-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .step-num {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 12px;
        color: #f24334;
        text-align: left;
        font-style: normal;
        margin-right: 8px;
        background: #fff;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
      }
    }
  }
  .card-content {
    border-radius: 12px;
    margin-top: -20px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    background-image: url("@/assets/style/landingPage/langpagecard-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .title {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: bold;
      color: #333333;
      text-align: left;
      font-style: normal;
      margin-top: 8px;
      text-align: center;
    }
    .num {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 54px;
      color: #333333;
      text-align: center;
      font-style: normal;
      margin-bottom: 16px;
    }
    .pageCardList {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .pageCardItem {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #333333;
        font-size: 14px;
        .icon {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
}
</style>
